import SearchIcon from "@mui/icons-material/Search";
import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "24px",
  backgroundColor: "var(--bg-page)",
  border: "1px solid var(--divider)",
  color: "var(--text-primary)",
  height: "36px",
  display: "flex",
  alignItems: "center",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "var(--surface)",
    borderColor: "var(--brand-primary)",
    boxShadow: "0 6px 16px rgba(8, 96, 211, 0.1)",
  },
  "&:focus-within": {
    backgroundColor: "var(--surface)",
    borderColor: "var(--brand-primary)",
    boxShadow: "0 0 0 3px rgba(32, 141, 233, 0.14)",
  },
  marginRight: theme.spacing(0.3),
  marginLeft: "0 !important",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(2),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1.8),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  color: "var(--text-secondary)",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontSize: "13px",
  fontWeight: 500,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1.5, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "120px",
      "&:focus": {
        width: "180px",
      },
    },
  },
}));

export const SearchBar = ({ onSearch, value, placeholder = "Search fleet..." }) => {
  return (
    <>
      <Search>
        <SearchIconWrapper>
          <SearchIcon sx={{ fontSize: 18 }} />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder={placeholder}
          inputProps={{ "aria-label": "search" }}
          value={value}
          onChange={onSearch}
        />
      </Search>
    </>
  );
};

